import { render, staticRenderFns } from "./item-list.vue?vue&type=template&id=f71b3b76&scoped=true"
import script from "./item-list.vue?vue&type=script&lang=js"
export * from "./item-list.vue?vue&type=script&lang=js"
import style0 from "./item-list.vue?vue&type=style&index=0&id=f71b3b76&prod&lang=css"
import style1 from "./item-list.vue?vue&type=style&index=1&id=f71b3b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71b3b76",
  null
  
)

export default component.exports